// removed by extract-text-webpack-plugin
module.exports = {"RoundedRectangleButton":"qvsiswbzADwaN6PC8xXIv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RoundedRectangleButton/index.css
// module id = 1447
// module chunks = 1